import React, { useState } from 'react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito experiencia previa con el chocolate?',
    a: 'No. Diseñado para principiantes hasta reposteras con experiencia. Cada técnica explicada paso a paso.'
  }, {
    q: '¿Necesito comprar maquinaria cara?',
    a: 'Para nada. Termómetro láser básico y herramientas de cocina simples. Sin mármol, sin atemperadora.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago recibís email con acceso a todos los tomos y bonos en PDF descargable.'
  }, {
    q: '¿Puedo pagar en cuotas?',
    a: 'Sí. Mercado Pago con hasta 6 cuotas. También transferencia bancaria o link de pago.'
  }, {
    q: '¿Y si no me gusta o no funciona?',
    a: '30 días para pedir reembolso completo. Sin preguntas, sin formularios complicados.'
  }, {
    q: '¿Sirve para todo el país?',
    a: 'Sí, adaptado a toda Argentina. Proveedores para CABA, interior y compras online con envío nacional.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-10 px-5 bg-negro-suave" data-id="element-58">
      <h2 className="font-playfair text-[clamp(22px,3.5vw,34px)] text-center text-blanco mb-6" data-id="element-59">
        Preguntas Frecuentes
      </h2>
      <div className="max-w-[750px] mx-auto" data-id="element-60">
        {faqs.map((faq, i) => <div key={i} className="bg-[#1e1e1e] rounded-xl mb-2 border border-[rgba(201,149,108,0.15)] overflow-hidden transition-all duration-300 hover:border-oro-rosa" data-id="element-61">
            <div className="py-3.5 px-5 text-[15px] font-bold text-oro-rosa-claro cursor-pointer flex justify-between items-center" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-62">
              {faq.q}
              <span className={`text-[11px] text-dorado transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-63">
                ▼
              </span>
            </div>
            {openIndex === i && <div className="px-5 pb-3.5 text-[14px] text-[#cccccc] leading-[1.6]" data-id="element-64">
                {faq.a}
              </div>}
          </div>)}
      </div>
    </section>;
}